/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { BoundingBox2d } from './BoundingBox2d'
import {
  BoundingBox2dFromJSON,
  BoundingBox2dFromJSONTyped,
  BoundingBox2dToJSON,
} from './BoundingBox2d'

/**
 * Intended to help with positioning of the DDW highlight marker.
 *
 * We are not exposing all bounding boxes for now, only the minimum
 * required.
 * @export
 * @interface FlexImageSuccessResultBoundingBoxResult
 */
export interface FlexImageSuccessResultBoundingBoxResult {
  /**
   *
   * @type {BoundingBox2d}
   * @memberof FlexImageSuccessResultBoundingBoxResult
   */
  truckWithoutShadow?: BoundingBox2d | null
  /**
   *
   * @type {BoundingBox2d}
   * @memberof FlexImageSuccessResultBoundingBoxResult
   */
  wipers?: BoundingBox2d | null
}

/**
 * Check if a given object implements the FlexImageSuccessResultBoundingBoxResult interface.
 */
export function instanceOfFlexImageSuccessResultBoundingBoxResult(
  value: object,
): boolean {
  let isInstance = true

  return isInstance
}

export function FlexImageSuccessResultBoundingBoxResultFromJSON(
  json: any,
): FlexImageSuccessResultBoundingBoxResult {
  return FlexImageSuccessResultBoundingBoxResultFromJSONTyped(json, false)
}

export function FlexImageSuccessResultBoundingBoxResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FlexImageSuccessResultBoundingBoxResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    truckWithoutShadow: !exists(json, 'truckWithoutShadow')
      ? undefined
      : BoundingBox2dFromJSON(json['truckWithoutShadow']),
    wipers: !exists(json, 'wipers')
      ? undefined
      : BoundingBox2dFromJSON(json['wipers']),
  }
}

export function FlexImageSuccessResultBoundingBoxResultToJSON(
  value?: FlexImageSuccessResultBoundingBoxResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    truckWithoutShadow: BoundingBox2dToJSON(value.truckWithoutShadow),
    wipers: BoundingBox2dToJSON(value.wipers),
  }
}
